import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';
import { API_BASE_URL } from '../constants/api';

export const bookingsApi = createApi({
  reducerPath: 'bookingsApi',
  baseQuery: createAuthBaseQuery(API_BASE_URL),
  tagTypes: ['Booking'],
  endpoints: (builder) => ({
    listBookings: builder.query({
      query: () => '/bookings',
      providesTags: ['Booking'],
    }),
    getBooking: builder.query({
      query: (bookingId) => `/bookings/${encodeURIComponent(bookingId)}`,
      providesTags: (_res, _err, id) => [{ type: 'Booking', id }],
    }),
    createBooking: builder.mutation({
      query: (body) => ({ url: '/bookings', method: 'POST', body }),
      invalidatesTags: ['Booking'],
    }),
    cancelBooking: builder.mutation({
      query: ({ bookingId, reason }) => ({
        url: `/bookings/${encodeURIComponent(bookingId)}/cancel`,
        method: 'POST',
        body: { reason },
      }),
      invalidatesTags: ['Booking'],
    }),
    initiatePayu: builder.mutation({
      query: (body) => ({ url: '/payments/payu/initiate', method: 'POST', body }),
    }),
  }),
});

export const {
  useListBookingsQuery,
  useGetBookingQuery,
  useCreateBookingMutation,
  useCancelBookingMutation,
  useInitiatePayuMutation,
} = bookingsApi;
